import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox6} from '../components';

class Dashboard6 extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox6/>
			</Fragment>
		);
	}
}

Dashboard6.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard6.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard6;